module.exports = __webpack_public_path__ + "img/i20.2b6126ec.svg";